var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { UserType } from "healthex-common/user.dtos";
export class AccountSettingsViewModel {
    constructor(container) {
        this.accountSettingsUIManager = container.accountSettingsUIManager;
        this.authManager = container.authManager;
    }
    get pageTitle() {
        return this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION ? "Account" : "Account Settings";
    }
    get currentSubPage() {
        return this.accountSettingsUIManager.currentSubPage;
    }
    setCurrentSubPage(subPage) {
        this.accountSettingsUIManager.setCurrentSubPage(subPage);
    }
    get showProfileTab() {
        return (this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION ||
            this.authManager.userType === UserType.EXTERNAL_RESEARCHER ||
            this.authManager.userType === UserType.SERVICE_PROVIDER);
    }
    get showLoginAndSecurityTab() {
        return (this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION ||
            this.authManager.userType === UserType.EXTERNAL_RESEARCHER ||
            this.authManager.userType === UserType.SERVICE_PROVIDER);
    }
    get showAboutYourOrgTab() {
        return this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION;
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsViewModel.prototype, "pageTitle", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsViewModel.prototype, "currentSubPage", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsViewModel.prototype, "showProfileTab", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsViewModel.prototype, "showLoginAndSecurityTab", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsViewModel.prototype, "showAboutYourOrgTab", null);
